//countries and code are update from the api
export const COUNTRIES = {};
export const COUNTRY_PHONE_LENGTHS = {};

export const updateCountryData = (countries, phoneLengths) => {
  if (countries && Object.keys(countries).length > 0) {
    COUNTRIES = { ...countries };
  }
  
  if (phoneLengths && Object.keys(phoneLengths).length > 0) {
    COUNTRY_PHONE_LENGTHS = { ...phoneLengths };
  }
};

export const validateInput = (
  type,
  value,
  confirmPassword = "",
  additionalValue = ""
) => {
  const errors = {};
  switch (type) {

    case "mobile":
      if (!value) {
        errors.mobile = "Mobile number is required";
      } else {
        const currentCountryCode = additionalValue; // Pass country code as additionalValue
        const expectedLength = COUNTRY_PHONE_LENGTHS[currentCountryCode];
        if (!expectedLength) {
          errors.mobile = "Invalid or unsupported country code";
        } else {
          const mobilePattern = new RegExp(`^[0-9]{${expectedLength}}$`);
          if (!mobilePattern.test(value)) {
            errors.mobile = `Mobile number must be exactly ${expectedLength} digits for ${currentCountryCode}`;
          }
        }
      }
      break;

    case "username":
      if (!value) {
        errors.username = "Username is required";
      } else if (!value.trim()) {
        errors.username = "Username cannot be empty or only spaces";
      }
      //  else if (value.length < 5) {
      //   errors.username = "Username must be at least 5 characters long";
      // }
       else if (!/^[a-zA-Z\s]+$/.test(value)) {
        errors.username = "Username can only contain letters and spaces";
      }
      break;

      case "companyName":
        if (!value) {
          errors.companyName = "Company Name is required";
        } else if (!value.trim()) {
          errors.companyName = "Company Name cannot be empty or only spaces";
        } else if (value.length < 5) {
          errors.companyName = "Company Name must be at least 5 characters long";
        } else if (value.length > 100) {
          errors.companyName = "Company Name must not exceed 100 characters";
        } else if (!/\b\w+\b/.test(value)) {
          errors.companyName = "Company Name must contain at least one word";
        } else if (/[^a-zA-Z0-9\s&.,'-]/.test(value)) {
          errors.companyName = "Company Name contains invalid characters";
        } else if (/\s{2,}/.test(value)) {
          errors.companyName = "Company Name cannot contain consecutive spaces";
        } else if (/^\d+$/.test(value)) {
          errors.companyName = "Company Name cannot be numeric-only";
        }
        break;
      

    case "password":
      if (!value) {
        errors.password = "Password is required";
      }
      // Additional password validations can be added here, e.g., length, character types
      break;

    case "confirmPassword":
      if (!value) {
        errors.confirmPassword = "Confirm Password is required";
      } else if (value !== confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
      }
      break;

    case "email":
      if (!value) {
        errors.email = "Email ID is required";
      } else {
        // Basic email format validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
          errors.email = "Invalid email format";
        }
      }
      break;

      case "countryCode":
        if (!value) {
          errors.countryCode = "Country code is required";
        } else if (!/^\+\d{1,4}$/.test(value)) {
          errors.countryCode = "Invalid country code format (e.g., +1, +91, +971)";
        } else if (!(value in COUNTRY_PHONE_LENGTHS)) {
          errors.countryCode = "Invalid or unsupported country code";
        }
        break;

    case "employeeCode":
      if (!value) {
        errors.employeeCode = "Employee code is required";
      } else {
        // Alphanumeric check (no special characters)
        const alphanumericPattern = /^[a-zA-Z0-9]+$/;
        if (!alphanumericPattern.test(value)) {
          errors.employeeCode =
            "Employee code must be alphanumeric (no special characters)";
        }
      }
      break;

    case "faqQuestion":
      if (!value) {
        errors.faqQuestion = "Question is required";
      } else if (value.trim().length < 10) {
        errors.faqQuestion = "Question must be at least 10 characters long";
      }
      break;

    case "faqAnswer":
      if (!value) {
        errors.faqAnswer = "Answer is required";
      } else if (value.trim().length < 20) {
        errors.faqAnswer = "Answer must be at least 20 characters long";
      }
      break;

    case "offerCredits":
      if (!value) {
        errors.credits = "Credits are required";
      } else if (isNaN(value) || value <= 0) {
        errors.credits = "Credits must be a positive number";
      }
      break;

    case "offerCodes":
      if (!value) {
        errors.codes = "Offer Code is required";
      } else if (!/^[a-zA-Z0-9]+$/.test(value)) {
        errors.codes = "Offer Code must be alphanumeric";
      } else if (value.length < 5 || value.length > 10) {
        errors.codes = "Offer Code must be between 5 and 10 characters long";
      }
      break;

    case "bannerTitle":
      if (!value) {
        errors.bannerTitle = "Banner title is required";
      } else if (value.trim().length < 5) {
        errors.bannerTitle = "Banner title must be at least 5 characters long";
      }
      break;

    case "productName":
      if (!value) {
        errors.productName = "Product Name is required";
      } else if (value.trim().length < 5) {
        errors.productName = "Product Name must be at least 5 characters long";
      }
      break;

    case "category":
      if (!value) {
        errors.category = "Category is required";
      }
      break;

    case "multipleUpload":
      if (value.length <= 0) {
        errors.multipleUpload = "Please upload at least one image for the product";
      }
      break;

    case "learningType":
      if (!value) {
        errors.learningType = "Learning Type is required";
      }
      break;

    case "companyType":
      if (!value) {
        errors.companyType = "Company Type is required";
      }
      break;

    case "industry":
      if (!value) {
        errors.industry = "Industry is required";
      }
      break;

    case "department":
      if (!value) {
        errors.department = "Department is required";
      }
      break;

    case "position":
      if (!value) {
        errors.position = "Position is required";
      } else if (!value.trim()) {
        errors.position = "Position cannot be empty or only spaces";
      }
      break;

    case "selectedType":
      if (!value) {
        errors.selectedType = "Type is required";
      }
      break;

    case "sub_category":
      if (!value) {
        errors.sub_category = "Sub Category is required";
      }
      break;

    case "maxFlowrate" :
      if(!value){
        errors.maxFlowrate = "Max Flowrate is required";
      }
      break;
    
    case "workingPressure":
      if(!value){
        errors.workingPressure = "Working Pressure is required";
      }
      break;
    
    case "ratedStaticburst":
      if(!value){
        errors.ratedStaticburst = "Rated Staticburst is required";
      }
      break;

    case "baldwin":
      if (!value) {
        errors.baldwin = "Baldwin is required";
      }
      break;

    case "fleetguard":
      if (!value) {
        errors.fleetguard = "Fleetguard is required";
      }
      break;

    case "hifi":
      if (!value) {
        errors.hifi = "Hifi is required";
      }
      break;

    case "sakura":
      if (!value) {
        errors.sakura = "Sakura is required";
      }
      break;

    case "donaldson":
      if (!value) {
        errors.donaldson = "Donaldson is required";
      }
      break;

    case "hengst":
      if (!value) {
        errors.hengst = "Hengst is required";
      }
      break;

    case "wix":
      if (!value) {
        errors.wix = "WIX is required";
      }
      break;
    
      case "mann":
      if (!value) {
        errors.mann = "Mann is required";
      }
      break;

      case "maxViscosity":
        if (!value) {
          errors.maxViscosity = "Max Viscosity is required";
        }
        break;

        case "mountingConnection":
      if (!value) {
        errors.mountingConnection = "Mounting Connection is required";
      }
      break;
      case "housingOption":
      if (!value) {
        errors.housingOption = "Housing Option is required";
      }
      break;
      case "productOptions":
      if (!value) {
        errors.productOptions = "Product Options is required";
      }
      break;
      case "otherOption":
      if (!value) {
        errors.otherOption = "Other Options is required";
      }
      break;
    case "industryTrainingLearningType":
      if (!value) {
        errors.learningType = "Learning Type is required";
      }
      break;

    case "gearboxTorqueRange":
      if (!value) {
        errors.gearboxTorqueRange = "Gearbox Torque Range is required";
      }
      break;
  
    case "gearboxRatios":
      if (!value) {
        errors.gearboxRatios = "Gearbox Ratios is required";
      }
      break;

    case "gearboxMechanicalRating":
      if (!value) {
        errors.gearboxMechanicalRating = "Gearbox Mechanical Rating is required";
      }
      break;

    case "gearboxSizes":
      if (!value || value.length === 0) {
        errors.gearboxSizes = "Gearbox Sizes is required";
      }
      break;

    case "gearboxInput":
      if (!value) {
        errors.gearboxInput = "Gearbox Input is required";
      }
      break;

    case "gearboxOutput":
      if (!value) {
        errors.gearboxOutput = "Gearbox Output is required";
      }
      break;

    case "learningTitle":
      if (!value) {
        errors.learningTitle = "Learning Title is required";
      } else if (value.trim().length < 5) {
        errors.learningTitle =
          "Learning Title must be at least 5 characters long";
      }
      break;

    case "description":
      if (!value) {
        errors.description = "Description is required";
      } else if (value.trim().length < 10) {
        errors.description = "Description must be at least 10 characters long";
      }
      break;

    case "offerNotes":
      if (!value) {
        errors.offerNotes = "Notes is required";
      } else if (value.trim().length < 10) {
        errors.offerNotes = "Notes must be at least 10 characters long";
      }
      break;

    case "startDate":
      if (!value) {
        errors.startDate = "Start date is required";
      }
      break;

    case "endDate":
      if (!value) {
        errors.endDate = "End date is required";
      } else if (new Date(value) < new Date(additionalValue)) {
        errors.endDate = "End date cannot be earlier than start date";
      }
      break;

    case "notes":
      if (!value) {
        errors.notes = "Notes are required";
      } else if (value.trim().length < 10) {
        errors.notes = "Notes must be at least 10 characters long";
      }
      break;

    case "file":
      if (!value) {
        errors.file = "file is required";
      }
      break;

    case "videoLink":
      if (!value) {
        errors.videoLink = "Video Link is required";
      } else if (
        !/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
          value
        )
      ) {
        errors.videoLink = "Invalid URL format";
      }
      break;

    // Additional validation cases can be added here as needed

    default:
      break;
  }

  return errors;
};
